export enum CheckoutParamEnum {
  step = 'step',
  propertyId = 'propertyId',
  bookingId = 'bookingId',
  startDate = 'startDate',
  endDate = 'endDate',
  adults = 'adults',
  children = 'children',
  infants = 'infants',
  pets = 'pets',
  paymentType = 'paymentType',
  message = 'message',
  marketing = 'marketing',
  owner_offer_code = 'owner_offer_code',
  owner_offer_id = 'owner_offer_id',
  allura_offer_code = 'allura_offer_code',
  allura_offer_id = 'allura_offer_id',
  owner_gift_certificate_code = 'owner_gift_certificate_code',
  owner_gift_certificate_id = 'owner_gift_certificate_id',
  allura_gift_certificate_code = 'allura_gift_certificate_code',
  allura_gift_certificate_id = 'allura_gift_certificate_id',
  promo_not_used_confirm = 'promo_not_used_confirm',
  currency_code = 'currency_code',
  currency_multiplier = 'currency_multiplier',
}

export enum CheckoutUserFlowEnum {
  Login = 1,
  ForgotPassword,
  CreateAccount,
}

export enum PaymentTypeEnum {
  PayInFull = 1,
  DepositBalanceDue = 2,
}
